export const SET_COPY_OF_MANUAL_CASH_LIMIT_DATA = 'SET_COPY_OF_MANUAL_CASH_LIMIT_DATA';
export const setCopyOfManualCashLimitData = (manualCashLimit) => ({
    type: SET_COPY_OF_MANUAL_CASH_LIMIT_DATA,
    payload: {
        memberId: manualCashLimit.member.memberId,
        limitValue: manualCashLimit.limitValue,
        beginDate: manualCashLimit.beginDate,
        endDate: manualCashLimit.endDate,
        currencyCode: manualCashLimit.currency.code,
        clearingHouseCode: manualCashLimit.clearingHouse.code,
        description: manualCashLimit.description,
    },
});

export const REMOVE_COPY_OF_MANUAL_CASH_LIMIT_DATA = 'REMOVE_COPY_OF_MANUAL_CASH_LIMIT_DATA';
export const removeCopyOfManualCashLimitData = () => ({
    type: REMOVE_COPY_OF_MANUAL_CASH_LIMIT_DATA,
});
